import script from "./ProceedCS.vue?vue&type=script&setup=true&lang=js"
export * from "./ProceedCS.vue?vue&type=script&setup=true&lang=js"

import "./ProceedCS.vue?vue&type=style&index=0&id=6cab77c3&lang=css"

const __exports__ = script;

export default __exports__